import React from 'react';

import styles from './Texts.module.scss';
interface InfoTextLineProps {
  value: string | number;
}

export const InfoTextLine: React.FC<InfoTextLineProps> = ({ value }) => (
  <InfoTextLineItem>{value}</InfoTextLineItem>
);

const InfoTextLineItem = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={
      className ? `${styles['info-text-line-item']} ${className}` : styles['info-text-line-item']
    }
    {...props}
  />
);

export const BlueLine = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['blue-line']} ${className}` : styles['blue-line']}
    {...props}
  />
);

export const Description = ({ className, ...props }: React.ComponentPropsWithoutRef<'p'>) => (
  <p
    className={className ? `${styles['description']} ${className}` : styles['description']}
    {...props}
  />
);
